import Constants from 'expo-constants'
import { Dimensions, StatusBar } from 'react-native'
import theme from '../../../theme'

const styles = {
    go_to_container: {
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        paddingHorizontal: 10,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}

export default styles
